import clsx from 'clsx';
import style from './block.module.scss';

function TableOfContents({ categories, guides, currentGuide }) {
    return categories ? (
        <div className={style.block}>
            {categories.map((category, key) => {
                const isCurrent = guides.find((guide) => guide.category === category.id && currentGuide === guide.id);

                return (
                    <details key={category.id} open={isCurrent}>
                        <summary>
                            <p className={style.title}>{category.name}</p>
                        </summary>
                        <ul className={style.listeHeading}>
                            {guides
                                .filter((guide) => guide.category === category.id)
                                .map((guide) => {
                                    return (
                                        <GuideLink key={guide.id} isActive={currentGuide === guide.id} guide={guide} />
                                    );
                                })}
                        </ul>
                    </details>
                );
            })}
        </div>
    ) : null;
}

const GuideLink = ({ guide, isActive }) => {
    return (
        <li>
            <a
                href={guide.link}
                className={clsx(isActive && style.active)}
                dangerouslySetInnerHTML={{ __html: guide.title }}
            />
        </li>
    );
};

export default TableOfContents;
